import styled from "@emotion/styled";
import { Select } from "@material-ui/core";

import { units } from "../../../../../../types/units";

export const StyledSelect = styled(Select)`
  &.warning {
    .MuiSelect-select.MuiSelect-select {
      border-bottom: 2px solid;
      ${units({
        borderColor: "red",
      })};
    }
  }
`;
